import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 24}
        height={props.height ?? 24}
        fill="none"
        {...props}
    >
        <Path
            fill={props.color || designSystem.colors.neutral300}
            d="m14.096 10.93-.53.531.53-.53ZM9.5 17.649l.53.53 4.597-4.595-.53-.53-.531-.531-4.596 4.596.53.53Zm4.596-6.717.53-.53-4.596-4.597-.53.53-.53.531 4.596 4.596.53-.53Zm0 2.121.53.53a2.25 2.25 0 0 0 0-3.181l-.53.53-.53.53a.75.75 0 0 1 0 1.06l.53.531Z"
        />
    </Svg>
);
export default SvgComponent;
